// import { PDFPage, RGB, rgb } from "pdf-lib/cjs/api";

// Use global CDN objects
// const { rgb } = window.PDFLib;

/**
 * Draw horizontal line
 */
export const drawHorizontalLine = ({
  page,
  x,
  y,
  width,
  color,
  opacity = 0.8,
}: {
  page: any;
  x: number;
  y: number;
  width: number;
  color: any;
  opacity?: number;
}): void => {
  page.drawLine({
    start: { x, y },
    end: { x: x + width, y },
    color,
    opacity,
  });
};

/**
 * Dessine un rectangle avec coins arrondis en utilisant drawSvgPath
 */
export const drawRoundedRectangle = ({
  page,
  x,
  y,
  width,
  height,
  radius,
  fillColor,
  borderColor = null,
  borderWidth = 1,
  opacity = 0.8,
}: {
  page: any;
  x: number;
  y: number;
  width: number;
  height: number;
  radius: number;
  fillColor: any;
  borderColor?: any | null;
  borderWidth?: number;
  opacity?: number;
}): void => {
  // Limiter le radius à la moitié de la plus petite dimension
  const maxRadius = Math.min(width, height) / 2;
  const r = Math.min(radius, maxRadius);

  width = Math.round(width);
  height = Math.round(height);

  // Créer le chemin SVG pour un rectangle aux coins arrondis
  const svgPath = `
        M ${r} 0
        L ${width - r} 0
        Q ${width} 0 ${width} ${r}
        L ${width} ${height - r}
        Q ${width} ${height} ${width - r} ${height}
        L ${r} ${height}
        Q 0 ${height} 0 ${height - r}
        L 0 ${r}
        Q 0 0 ${r} 0
        Z
      `
    .replace(/\s+/g, " ")
    .trim();

  // Dessiner avec drawSvgPath
  page.drawSvgPath(svgPath, {
    x: x,
    y: y,
    color: fillColor,
    borderColor: borderColor && borderWidth > 0 ? borderColor : undefined,
    borderWidth: borderWidth,
    opacity: opacity,
  });
};
